import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import fonctionnalites1 from '../fonctionnalites1.png';
import fonctionnalites2 from '../fonctionnalites2.png';
import fonctionnalites3 from '../fonctionnalites3.png';
import fonctionnalites4 from '../fonctionnalites4.png';
import { FaUser, FaLock, FaCheck, FaBook } from 'react-icons/fa';
import { BsHeart, BsShieldCheck, BsChatDots, BsPersonCheck } from "react-icons/bs";
import { TfiWrite } from "react-icons/tfi";
import { IoPersonOutline } from "react-icons/io5";
import { BiSearchAlt } from "react-icons/bi";
import { RiChatHeartLine } from "react-icons/ri";
import { MdFamilyRestroom, MdSupportAgent } from "react-icons/md";
import { useAuth } from '../context/AuthContext';
import NavbarAuth from '../components/NavbarAuth';
const Fonctionnalites = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { isSmall: isSmallMobile, isMobile, isTablet } = useResponsive();

    return (
        <div style={styles.container}>

            {/* ═══════════ NAVBAR ═══════════ */}
            {user ? <NavbarAuth /> : <Navbar />}

            {/* ═══════════ HERO ═══════════ */}
            <section style={{
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: '#fff',
                minHeight: isSmallMobile ? '300px' : isMobile ? '360px' : isTablet ? '380px' : 'auto',
            }}>
                {!isMobile && (
                    <div style={{ position: 'absolute', top: 0, right: 0, height: '100%', width: '100%' }}>
                        <img src={fonctionnalites1} alt="" style={{
                            width: '100%', height: '100%',
                            objectFit: 'cover', objectPosition: 'center',
                            display: 'block',
                        }} />
                        <div style={{ position: 'absolute', inset: 0 }} />
                    </div>
                )}
                {isMobile && (
                    <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(255,255,255,0.95)' }} />
                )}
                <div style={{
                    position: 'relative', zIndex: 2,
                    maxWidth: isMobile ? '100%' : isTablet ? '60%' : '50%',
                    padding: isSmallMobile ? '32px 16px' : isMobile ? '48px 24px' : isTablet ? '52px 48px' : '80px 94px',
                    display: 'flex', flexDirection: 'column',
                    alignItems: isMobile ? 'center' : 'flex-start',
                    textAlign: isMobile ? 'center' : 'left',
                }}>
                    <p style={{ color: '#781840', fontSize: isSmallMobile ? '10px' : '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '16px', marginTop: 0 }}>
                        NOS FONCTIONNALITÉS
                    </p>
                    <h1 style={{ color: '#1a0010', fontWeight: '700', fontSize: isSmallMobile ? '24px' : isMobile ? '32px' : isTablet ? '36px' : '48px', lineHeight: '1.2', marginBottom: '0', marginTop: 0 }}>
                        Des outils pensés pour<br />vous rapprocher,<br />dans le{' '}
                        <span style={{ color: '#781840' }}>respect et la sérénité.</span>
                    </h1>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: '20px 0' }}>
                        <div style={{ width: '32px', height: '2px', backgroundColor: '#781840' }} />
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                        <div style={{ width: '32px', height: '2px', backgroundColor: '#781840' }} />
                    </div>
                    <p style={{ color: '#555', lineHeight: '1.8', fontSize: isSmallMobile ? '13px' : '14px', margin: 0, maxWidth: '440px' }}>
                        Zawaj & Tawadud met à votre disposition des fonctionnalités innovantes et éthiques pour vous accompagner à chaque étape de votre recherche d'une union bénie.
                    </p>
                </div>
            </section>

            {/* ═══════════ FEATURES GRID ═══════════ */}
            <section style={{ backgroundColor: '#fff', padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 16px' : isTablet ? '48px 20px' : '48px 24px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '18px' : isMobile ? '22px' : isTablet ? '24px' : '28px', fontWeight: '700', textAlign: 'center', marginBottom: '12px', marginTop: 0 }}>
                        Des fonctionnalités au service de vos valeurs
                    </h2>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: isSmallMobile ? '24px' : '40px' }}>
                        <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                        <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isSmallMobile ? '1fr' : isMobile ? '1fr 1fr' : isTablet ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
                        gap: isSmallMobile ? '12px' : '16px',
                    }}>
                        {[
                            { icon: <BsPersonCheck size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Profils authentiques et vérifiés', text: "Des profils vérifiés manuellement pour garantir l'authenticité et la sincérité de chaque membre." },
                            { icon: <BiSearchAlt size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Recherche avancée et ciblée', text: 'Trouvez des profils compatibles selon vos critères, vos valeurs et vos objectifs de mariage.' },
                            { icon: <BsChatDots size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Messagerie sécurisée', text: 'Échangez en toute sécurité grâce à notre messagerie interne respectant les règles islamiques.' },
                            { icon: <MdFamilyRestroom size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Implication des familles', text: "Permettez l'implication des familles dans le processus pour un cadre sérieux et transparent." },
                            { icon: <FaBook size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Ressources et conseils', text: 'Accédez à des articles, rappels et conseils pour vous guider vers une union réussie.' },
                            { icon: <FaLock size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Confidentialité garantie', text: 'Vos données sont protégées et jamais partagées. Votre vie privée est notre priorité.' },
                            { icon: <MdSupportAgent size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Accompagnement personnalisé', text: "Bénéficiez d'un accompagnement bienveillant pour vous aider dans votre démarche." },
                            { icon: <BsHeart size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Une approche éthique et islamique', text: 'Chaque fonctionnalité est conçue selon les principes de la Sharia et les valeurs musulmanes.' },
                        ].map((f, i) => (
                            <div key={i} style={{
                                backgroundColor: 'white', borderRadius: '14px',
                                padding: isSmallMobile ? '14px 10px' : isMobile ? '16px 12px' : '24px 20px',
                                border: '1px solid #f0dde6',
                                boxShadow: '0 2px 12px rgba(192,48,106,0.06)',
                                textAlign: 'center',
                                display: 'flex', flexDirection: 'column', alignItems: 'center',
                            }}>
                                <div style={{
                                    width: isSmallMobile ? '44px' : '56px',
                                    height: isSmallMobile ? '44px' : '56px',
                                    border: '1px solid #f0dde6', borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    margin: '0 auto 12px',
                                }}>
                                    {f.icon}
                                </div>
                                <h3 style={{ color: '#1a0010', fontSize: isSmallMobile ? '12px' : isMobile ? '13px' : '14px', fontWeight: '700', marginBottom: '8px', marginTop: 0 }}>{f.title}</h3>
                                <p style={{ color: '#aaa', fontSize: isSmallMobile ? '11px' : isMobile ? '11px' : '13px', lineHeight: '1.7', margin: 0 }}>{f.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════ COMMENT ÇA MARCHE - DARK ═══════════ */}
            <section style={{
                position: 'relative',
                overflow: 'hidden',
                padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 20px' : isTablet ? '48px 40px' : '48px 80px',
                textAlign: 'center',
            }}>
                <img src={fonctionnalites4} alt="" style={{
                    position: 'absolute', top: 0, left: 0,
                    width: '100%', height: '100%',
                    objectFit: 'cover', display: 'block',
                }} />
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <h2 style={{ color: 'white', fontSize: isSmallMobile ? '18px' : isMobile ? '22px' : isTablet ? '24px' : '28px', fontWeight: '700', marginBottom: '12px', marginTop: 0 }}>
                        Une plateforme simple et efficace
                    </h2>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: isSmallMobile ? '24px' : '40px' }}>
                        <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                        <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'center' : 'flex-start',
                        justifyContent: 'center',
                        maxWidth: '1200px', margin: '0 auto',
                        gap: isMobile ? '24px' : '0',
                    }}>
                        {[
                            { icon: <TfiWrite size={isMobile ? 22 : 28} color="white" />, num: '1', title: 'Inscription', text: 'Créez votre compte en quelques minutes.' },
                            { icon: <IoPersonOutline size={isMobile ? 22 : 28} color="white" />, num: '2', title: 'Complétez votre profil', text: 'Renseignez vos informations et préférences.' },
                            { icon: <BiSearchAlt size={isMobile ? 22 : 28} color="white" />, num: '3', title: 'Trouvez des profils compatibles', text: 'Découvrez des profils qui vous correspondent.' },
                            { icon: <RiChatHeartLine size={isMobile ? 22 : 28} color="white" />, num: '4', title: 'Entamez une relation sérieuse', text: "Échangez dans le respect et avec l'intention du mariage." },
                        ].map((s, i, arr) => (
                            <React.Fragment key={i}>
                                <div style={{ flex: 1, textAlign: 'center', padding: isMobile ? '0' : '0 8px', maxWidth: isMobile ? '280px' : 'none' }}>
                                    <div style={{
                                        width: isSmallMobile ? '60px' : isMobile ? '70px' : '80px',
                                        height: isSmallMobile ? '60px' : isMobile ? '70px' : '80px',
                                        borderRadius: '50%',
                                        border: '2px solid #781840',
                                        backgroundColor: 'rgba(120,24,64,0.2)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        margin: '0 auto 12px',
                                    }}>
                                        {s.icon}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '6px' }}>
                                        <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#781840', color: 'white', borderRadius: '50%', width: '22px', height: '22px', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>{s.num}</div>
                                        <h3 style={{ color: 'white', fontSize: isSmallMobile ? '12px' : '14px', fontWeight: '700', margin: 0 }}>{s.title}</h3>
                                    </div>
                                    <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: isSmallMobile ? '11px' : '13px', lineHeight: '1.6', textAlign: 'center', margin: 0 }}>{s.text}</p>
                                </div>
                                {i < arr.length - 1 && !isMobile && (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px', flexShrink: 0, marginTop: '38px' }}>
                                        {[...Array(isTablet ? 8 : 12)].map((_, j) => (
                                            <div key={j} style={{ width: '3px', height: '3px', borderRadius: '50%', backgroundColor: 'white', flexShrink: 0 }} />
                                        ))}
                                    </div>
                                )}
                                {i < arr.length - 1 && isMobile && (
                                    <div style={{ width: '2px', height: '24px', backgroundColor: 'rgba(255,255,255,0.3)', margin: '0 auto' }} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════ ENGAGEMENT ═══════════ */}
            <section style={{
                position: 'relative',
                overflow: 'hidden',
                padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 16px' : isTablet ? '48px 32px' : '60px 48px',
                backgroundImage: `url(${fonctionnalites3})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}>
                <div style={{
                    position: 'relative', zIndex: 2,
                    maxWidth: '1200px', margin: '0 auto',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isTablet ? '16px' : '24px',
                    alignItems: isMobile ? 'center' : 'center',
                }}>
                    {/* Espace gauche (motif) */}
                    {!isMobile && (
                        <div style={{ flex: `0 0 ${isTablet ? '80px' : '180px'}` }} />
                    )}

                    {/* Titre + texte */}
                    <div style={{
                        flex: '0 0 auto',
                        maxWidth: isMobile ? '100%' : isTablet ? '200px' : '260px',
                        display: 'flex', flexDirection: 'column',
                        alignItems: isMobile ? 'center' : 'flex-start',
                        textAlign: isMobile ? 'center' : 'left',
                        borderRight: isMobile ? 'none' : '1px solid rgba(120,24,64,0.3)',
                        paddingRight: isMobile ? '0' : isTablet ? '20px' : '32px',
                        borderBottom: isMobile ? '1px solid rgba(120,24,64,0.2)' : 'none',
                        paddingBottom: isMobile ? '20px' : '0',
                    }}>
                        <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : isTablet ? '22px' : '28px', fontWeight: '700', lineHeight: '1.4', marginBottom: '16px', marginTop: 0 }}>
                            Notre engagement<br />envers vous
                        </h2>
                        <p style={{ color: '#444', fontSize: isSmallMobile ? '13px' : '14px', lineHeight: '1.9', margin: 0, maxWidth: '260px' }}>
                            Nous nous engageons à maintenir un environnement sain, éthique, sûr et conforme aux valeurs de l'Islam pour vous aider à trouver une union bénie.
                        </p>
                    </div>

                    {/* Checklist */}
                    <div style={{
                        flex: 1,
                        display: 'flex', flexDirection: 'column',
                        gap: isSmallMobile ? '12px' : '18px',
                        paddingLeft: isMobile ? '0' : isTablet ? '20px' : '32px',
                    }}>
                        {[
                            'Zéro tolérance face aux comportements inappropriés',
                            'Accompagnement basé sur la sincérité',
                            'Plateforme sans mixité non nécessaire',
                            'Modération humaine et bienveillante',
                            'Respect de la vie privée',
                        ].map((item, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '14px', justifyContent: 'flex-start', marginLeft: isMobile ? `${i * 16}px` : '0' }}>
                                <div style={{ width: '26px', height: '26px', borderRadius: '50%', border: '1.5px solid #781840', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <FaCheck color="#781840" size={10} />
                                </div>
                                <span style={{ color: '#333', fontSize: isSmallMobile ? '12px' : '14px', lineHeight: '1.5' }}>{item}</span>
                            </div>
                        ))}
                    </div>

                    {/* Badge shield */}
                    {!isSmallMobile && (
                        <div style={{ flex: `0 0 ${isTablet ? '120px' : '160px'}`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '14px', flexShrink: 0 }}>
                            <div style={{
                                backgroundColor: '#781840',
                                borderRadius: '50%',
                                width: isTablet ? '90px' : '120px',
                                height: isTablet ? '90px' : '120px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                boxShadow: '0 0 30px rgba(192,48,106,0.45), 0 0 60px rgba(192,48,106,0.2)',
                            }}>
                                <BsShieldCheck size={isTablet ? 36 : 50} color="white" />
                            </div>
                            <p style={{ color: '#1a0010', fontSize: isTablet ? '13px' : '15px', fontWeight: '700', lineHeight: '1.5', margin: 0, textAlign: 'center' }}>
                                Votre confiance<br />est notre priorité
                            </p>
                        </div>
                    )}
                </div>
            </section>

            {/* ═══════════ CTA ═══════════ */}
            <section style={{ position: 'relative', overflow: 'hidden' }}>
                <img src={fonctionnalites2} alt="" style={{
                    width: '100%', display: 'block',
                    objectFit: 'cover',
                    minHeight: isSmallMobile ? '200px' : isMobile ? '260px' : 'auto',
                }} />
                <div style={{
                    position: 'absolute', inset: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: isSmallMobile ? '0 12px' : isMobile ? '0 20px' : '0 48px',
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: isSmallMobile ? '12px' : isMobile ? '16px' : '20px',
                        width: isMobile ? '100%' : isTablet ? '80%' : '50%',
                        margin: '0 auto',
                    }}>
                        <div style={{ flex: 1, textAlign: isMobile ? 'center' : 'left' }}>
                            <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '16px' : isMobile ? '20px' : isTablet ? '22px' : '28px', fontWeight: '700', lineHeight: '1.4', marginBottom: '8px', marginTop: 0 }}>
                                Prêt à faire le premier pas<br />vers une <span style={{ color: '#781840' }}>union bénie</span> ?
                            </h2>
                            <p style={{ color: '#555', fontSize: isSmallMobile ? '12px' : '14px', lineHeight: '1.8', margin: 0 }}>
                                Rejoignez une communauté sérieuse et éthique.
                            </p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                            <button onClick={() => navigate('/register')} style={{
                                padding: isSmallMobile ? '10px 16px' : '14px 28px',
                                backgroundColor: '#781840', color: 'white',
                                border: 'none', borderRadius: '8px',
                                fontSize: isSmallMobile ? '13px' : '15px',
                                cursor: 'pointer', fontWeight: '600',
                                display: 'inline-flex', alignItems: 'center',
                                gap: '8px', whiteSpace: 'nowrap',
                            }}>
                                <FaUser size={13} /> Créer un compte gratuitement
                            </button>
                            <p style={{ color: '#555', fontSize: isSmallMobile ? '12px' : '13px', margin: 0, whiteSpace: 'nowrap' }}>
                                Déjà membre ?{' '}
                                <a href="#" onClick={(e) => { e.preventDefault(); navigate('/login'); }} style={{ color: '#781840', textDecoration: 'underline', fontWeight: '600', cursor: 'pointer' }}>
                                    Se connecter
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════ FOOTER ═══════════ */}
            <Footer />

        </div>
    );
};

const styles = {
    container: { fontFamily: 'Arial, sans-serif', overflowX: 'hidden' },
};

export default Fonctionnalites;